<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>生成码记录信息</span>
      </div>
      <el-form
        ref="createCodeForm"
        :model="createCodeInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label=" 区域：">
            <span>{{ createCodeInfo.typeName }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 起始值：">
            <span>{{ createCodeInfo.startCode }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 生成数量：">
            <span>{{ createCodeInfo.createCount }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 终止值：">
            <span>{{ createCodeInfo.endCode }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="服务地址：" prop="serviceUrl">
            <el-input v-model="createCodeInfo.serviceUrl"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入200个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      createCodeInfo: {
        createCodeRecordId: "",
        typeCode: "",
        typeName: "",
        createCount: "",
        startCode: "",
        endCode: "",
        serviceUrl: ""
      },
      rules: {
        serviceUrl: [
          {
            max: 200,
            message: "最多输入200个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getCreateCodeById: function(id) {
      let _this = this;
      let param = {
        url: "/api/createCode/getCreateCodeInfoById",
        params: {
          createCodeRecordId: id
        }
      };

      _this.$store.dispatch("getCreateCodeInfo", param).then(() => {
        _this.createCodeInfo =
          _this.$store.state.createCode.createCodeData.createCodeInfo;
      });
    },
    submit() {
      let _this = this;
      _this.$refs.createCodeForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/createCode/updateCreateCodeInfo",
            params: {
              createCodeRecordId: _this.createCodeInfo.createCodeRecordId,
              serviceUrl: _this.createCodeInfo.serviceUrl
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "已售产品码维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "createCodeIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善已售产品码信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.createCodeRecordId;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getCreateCodeById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
